import * as tslib_1 from "tslib";
import setClauseErrorText from '../actions/helpers/setClauseErrorText';
import setFocusedClauseId from '../actions/helpers/setFocusedClauseId';
import setClauseValue from '../actions/setClauseValue';
import store from '../store/store';
import { observer } from 'mobx-react';
import { DefaultButton } from 'office-ui-fabric-react/lib/Button';
import { getCategoryColorsForCategory, getCategoryMenuProps } from 'owa-categories';
import { getMasterCategoryList } from 'owa-categories';
import strings from 'owa-strings/owa-options-strings';
import * as React from 'react';
var styles = require('./InboxRuleClause.scss');
var classNames = require('classnames/bind').bind(styles);
var CategoryClauseValue = /** @class */ (function (_super) {
    tslib_1.__extends(CategoryClauseValue, _super);
    function CategoryClauseValue() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CategoryClauseValue.prototype.render = function () {
        var _this = this;
        var iconStyles;
        var clauseId = this.props.clauseId;
        var errorText = store.inboxRulesEditState.clauseErrorTextMap.get(clauseId);
        var clause = store.inboxRulesEditState.clauseMap.get(clauseId);
        // if the user selected a clause from the dropdown or has an existing clause,
        // set the categoryName class variable, which is used to update the UI
        if (clause.clauseValue) {
            this.categoryName = clause.clauseValue[0];
        }
        if (this.categoryName) {
            var categoryColor = getCategoryColorsForCategory(this.categoryName, getMasterCategoryList()).iconColor;
            iconStyles = { color: categoryColor };
        }
        var categoryMenuProps = getCategoryMenuProps('Rules', getMasterCategoryList(), [] /* categoriesToCheck */, function () {
            // we must explicitly call dismissMenu from the button ref because it does not close when focus is lost
            _this.categoryButtonRef.dismissMenu();
            setFocusedClauseId(clauseId, false /* shouldSetAsFocused */);
        }, true /* shouldShowSearchBox */, false /* shouldShowManageCategories */, false /* shouldShowClearCategories */, function (category, addCategoryPromise) {
            // update categoryName so UI will immediately update
            _this.categoryName = category;
            addCategoryPromise.then(function (wasSuccessful) {
                setClauseErrorText(clauseId, wasSuccessful /* isValidClause */, category);
                if (!wasSuccessful) {
                    // on failure, revert UI
                    _this.categoryName = null;
                    setClauseValue([], clauseId);
                }
                else {
                    setClauseValue([category], clauseId);
                }
            });
        }, function (category) { return setClauseValue([category], clauseId); } /* onCheckedCategoryClicked */, function (category) { return setClauseValue([category], clauseId); } /* onUncheckedCategoryClicked */, false /* manageCategoriesDisabled */, false /* createNewCategoriesDisabled */, null /* onManageCategoryClicked */, null /* onClearCategoriesClicked */, 1 /* topCenter */, true /* useTargetWidth */, true /* coverTarget */);
        var buttonStyles = {
            root: styles.categoryMoveToPickerButton,
            label: this.categoryName
                ? styles.categoryMoveToPickerText
                : styles.categoryMoveToPickerPlaceholderText,
        };
        return (React.createElement("div", { className: styles.categoryContainer },
            React.createElement(DefaultButton, { componentRef: function (ref) {
                    _this.categoryButtonRef = ref;
                }, text: this.categoryName
                    ? this.categoryName
                    : strings.options_inboxRules_categorizeDropdownPlaceholder, menuProps: categoryMenuProps, className: classNames(styles.categoryMoveToPickerButton, errorText && styles.hasError), styles: buttonStyles, iconProps: this.categoryName && {
                    iconName: "Tag" /* Tag */,
                    styles: {
                        root: iconStyles,
                    },
                } }),
            errorText && React.createElement("span", { className: styles.errorText }, errorText)));
    };
    CategoryClauseValue = tslib_1.__decorate([
        observer
    ], CategoryClauseValue);
    return CategoryClauseValue;
}(React.Component));
export default CategoryClauseValue;
//# sourceMappingURL=CategoryClauseValue.js.map